import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LeaveChatIcon } from '../icons/leave_chat_icon.svg';

export default function Regulations() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh',padding: '12px 16px 24px' }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Назад"
          style={{ border: 'none', background: 'transparent', padding: 4, cursor: 'pointer' }}
        >
          <LeaveChatIcon />
        </button>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>Регламенты</h1>
      </header>

      <section
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '16px 14px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
          color: '#374151',
          lineHeight: 1.45,
          fontSize: 16,
        }}
      >
        Регламенты будут добавлены позже.
      </section>
    </div>
  );
}

